import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";

import { ModalConfirmComponent } from "../confirm/modal-confirm.component";
import { LoadingService } from "../../loading/loading.service";
import { NoConformidad, MySubject, GlobalsService } from "../../../services/";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-modal-text",
  templateUrl: "./modal-text.component.html",
  styleUrls: ["./modal-text.component.scss"],
})
export class ModalTextComponent implements OnInit {
  @Input() id = "";
  @Input() numero="";
  @Input() data: any;
  @Input() title = "";
  @Input() content = "";
  @Input() remitir: any = false;
  @Input() listUser = [];

  apertura = "";
  selectId: any;
  responsable: any = {
    usuario_id_1: "",
    usuario_id_2: "",
    usuario_id_3: "",
    usuario_id_4: "",
    fecha_plazo: "",
    day_1: "",
    day_2: "",
    day_3: "",
  };
  indiceUser = ["usuario.id", "usuario.name"];
  datepickerConfig: any;
  messageObs: any;
  minDate: any;
  etiqueta: any;

  changeUpdate = new MySubject();

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private localeService: BsLocaleService,
    private noConformidad: NoConformidad,
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private router: Router,
    private globals: GlobalsService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.getTranslate();
    this.minDate = new Date();
    this.localeService.use(this.translate.currentLang);
    // console.log(this.translate.currentLang)
    this.datepickerConfig = {
      showWeekNumbers: false,
      dateInputFormat:
        this.translate.currentLang === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY",
    };
  }

  btnAceptar() {
    this.activeModal.close();
    if (this.apertura === "si") {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: "modal-basic-title",
        centered: true,
      });

      modalRef.componentInstance.title = this.etiqueta.apertura;
      modalRef.componentInstance.content = `${this.etiqueta.confirm_apertura} "${this.numero}" ?`;
      modalRef.componentInstance.info = true;
      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        const modal = this.modalService.open(ModalTextComponent, {
          ariaLabelledBy: "modal-basic-title",
          centered: true,
          size: "lg",
        });

        modal.componentInstance.title = this.etiqueta.responsibility_term;
        modal.componentInstance.remitir = "responsables";
        modal.componentInstance.id = this.id;
        modal.componentInstance.numero = this.numero;
        modal.componentInstance.listUser = this.listUser;
      });
    } else if (this.apertura === "no") {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: "modal-basic-title",
        centered: true,
      });

      modalRef.componentInstance.title = this.etiqueta.apertura;
      modalRef.componentInstance.content = this.etiqueta.return_nc;
      modalRef.componentInstance.info = true;
      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        const modal = this.modalService.open(ModalTextComponent, {
          ariaLabelledBy: "modal-basic-title",
          centered: true,
        });

        modal.componentInstance.title = this.etiqueta.observations;
        modal.componentInstance.remitir = "observacion";
        modal.componentInstance.id = this.id;
      });
    }
  }

  btnAceptarRemitir() {
    const data = {
      usuario_aprobador_id: this.selectId,
    };

    this.activeModal.close();

    this.loadingService.show();
    this.noConformidad.remitirAprobador(this.id, data).subscribe(
      (resp: any) => {
        this.loadingService.hide();
        this.toastrService.success(
          this.etiqueta.remitir_success,
          this.etiqueta.operation
        );
        this.router.navigate(["/gnc/validate"]);
      },
      (error: any) => {
        console.error("Hubo un error al actualizar el nuevo aprobador", error);
        this.loadingService.hide();
      }
    );
  }

  btnDismiss() {
    this.activeModal.dismiss();
  }

  selectItem(data: any) {
    this.selectId = data.id;
  }

  btnObservacion() {
    const data = {
      observaciones: this.messageObs,
    };

    this.activeModal.close();
    this.router.navigate(["/gnc/validate"]);

    this.noConformidad.observaciones(this.id, data).subscribe(
      (resp: any) => {
        this.toastrService.success(
          this.etiqueta.return_nc_2,
          this.etiqueta.operation
        );
      },
      (error: any) => {
        console.error(
          "Hubo un problema al enviar la observacion de la no conformidad",
          error
        );
      }
    );
  }

  btnResponsables() {
    if (this.responsable.usuario_id_1 && this.responsable.fecha_plazo) {
      const responsables = [];

      responsables[0] = {
        fase_id: 1,
        usuario_id: this.responsable.usuario_id_1,
        fecha_limite: moment(this.responsable.fecha_plazo).format("YYYY-MM-DD"),
        plazo: null,
      };

      if (this.responsable.usuario_id_2) {
        responsables[1] = {
          fase_id: 2,
          usuario_id: this.responsable.usuario_id_2,
          fecha_limite: null,
          plazo: this.responsable.day_1,
        };
      }

      if (this.responsable.usuario_id_3) {
        responsables[2] = {
          fase_id: 3,
          usuario_id: this.responsable.usuario_id_3,
          fecha_limite: null,
          plazo: this.responsable.day_2,
        };
      }

      if (this.responsable.usuario_id_4) {
        responsables[3] = {
          fase_id: 4,
          usuario_id: this.responsable.usuario_id_4,
          fecha_limite: null,
          plazo: this.responsable.day_3,
        };
      }

      const data = { responsables };

      console.log(data);

      this.activeModal.close();

      this.loadingService.show();
      this.noConformidad.apertura(this.id, data).subscribe(
        (resp: any) => {
          this.loadingService.hide();
          this.router.navigate(["/gnc/validate"]);
          this.toastrService.success(
            this.etiqueta.apertura_success,
            this.etiqueta.operation
          );
        },
        (error: any) => {
          console.error("Hubo un problema al guardar la apertura", error);
          this.toastrService.error(
            this.etiqueta.error_save_apertura,
            this.etiqueta.error
          );
          this.loadingService.hide();
        }
      );
    } else {
      this.toastrService.error(
        this.etiqueta.form_apertura,
        this.etiqueta.error
      );
    }
  }

  async getTranslate() {
    await this.globals.getTranslate("validation").subscribe((resp: any) => {
      this.etiqueta = resp;
    });
  }
}
